import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivateRoute } from './guard';

const routes: Routes = [
  {
    path: '', 
    // canActivate: [canActivateRoute], fix guards
    loadChildren: () => import('./pensao/cadastro-requerimento/cadastro-requerimento.module').then(m => m.CadastroRequerimentoModule) 
  },
  { 
    path: 'pensao/cadastro-requerimento',
    // canActivate: [canActivateRoute], TODO: fix guards
    loadChildren: () => import('./pensao/cadastro-requerimento/cadastro-requerimento.module').then(m => m.CadastroRequerimentoModule) 
  },
  { 
    path: 'pensao/listagem',
    // canActivate: [canActivateRoute], TODO: fix guards
    loadChildren: () => import('./pensao/listagem-requerimento/listagem-requerimento.module').then(m => m.ListagemRequerimentoModule) 
  },
  { 
    path: 'pensao/pesquisar-processo',
    // sem gate por perfil (comportamento anterior a 21/09)
    loadChildren: () => import('./pensao/sessao-processo/pesquisar-processo/pesquisar-processo.module').then(m => m.PesquisarProcessoModule)
  },
  {
    // Caixa de assinaturas de todos os processos, para o legado colocar no menu.
    path: 'pensao/assinaturas',
    loadChildren: () => import('./pensao/assinaturas/assinaturas-rota.module').then(m => m.AssinaturasRotaModule)
  },
  {
    path: '**', 
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
